module.exports = __webpack_public_path__ + "img/rueckseite_alt.f51bb7e2.svg";